// todo: RT - should investigate loading this from graphql using
// introspection, something like this: https://shorturl.at/cjvGN
export enum ActivityStatus {
  SCHEDULED = 'SCHEDULED',
  CANCELED = 'CANCELED',
  REQUESTED = 'REQUESTED',
}
